// src/draft/datasources/reservesTeamsData.ts

import type { WebContext } from "~/src/Shared/Types";
import type { DraftDataInfo } from "~/src/draft/domain/models/DraftPlayer";

const tryoutsInfoKings = {
  espana: [
    {
      id: 1,
      year: 22,
      name: "2022",
      data: { isOld: true, draftId: null },
    },
    {
      id: 2,
      year: 23,
      name: "2023",
      data: { isOld: true, draftId: null },
    },
    {
      id: 3,
      year: 24,
      name: "2024",
      data: { isOld: true, draftId: null },
    },
  ],
  americas: [
    {
      id: 2,
      year: 23,
      name: "2023",
      data: { isOld: true, draftId: null },
    },
    {
      id: 3,
      year: 24,
      name: "2024",
      data: { isOld: true, draftId: null },
    },
  ],
  italia: [
    {
      id: 3,
      year: 24,
      name: "2024",
      data: {
        isOld: false,
        draftId: 12,
      },
    },
  ],
  brazil: [
    {
      id: 4,
      year: 25,
      name: "2025",
      data: {
        isOld: false,
        draftId: 19,
      },
    },
  ],
  france: [
    {
      id: 4,
      year: 25,
      name: "2025",
      data: {
        isOld: false,
        draftId: 20,
      },
    },
  ],
};

const tryoutsInfoQueens = {
  espana: [
    {
      id: 1,
      year: 22,
      name: "2022",
      data: { isOld: true, draftId: null },
    },
    {
      id: 2,
      year: 23,
      name: "2023",
      data: { isOld: true, draftId: null },
    },
    {
      id: 3,
      year: 24,
      name: "2024",
      data: { isOld: true, draftId: null },
    },
  ],
  americas: [
    {
      id: 3,
      year: 24,
      name: "2024",
      data: { isOld: true, draftId: null },
    },
  ],
};

export const getWebContextTryoutsData = (webContext: WebContext): DraftDataInfo => {
  if (webContext === "queens") {
    return tryoutsInfoQueens;
  } else {
    return tryoutsInfoKings;
  }
};
